"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../..");

var _reactUseMeasure = _interopRequireDefault(require("react-use-measure"));

var _resizeObserver = require("@juggle/resize-observer");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./NumberTicker.css");

var _styles = {
  "number-ticker": "NumberTicker__number-ticker___1m9bY",
  "prefix": "NumberTicker__prefix___1oVdg",
  "prefix-text": "NumberTicker__prefix-text___3VFzF",
  "sizing-text": "NumberTicker__sizing-text___3MLxV",
  "sizing-ref": "NumberTicker__sizing-ref___1J_rS",
  "digit-bar": "NumberTicker__digit-bar___3XLVm",
  "digit-bar-content": "NumberTicker__digit-bar-content___29W11",
  "digit": "NumberTicker__digit___1-lNm",
  "digit-slider": "NumberTicker__digit-slider___1WNx_"
};

const styles = _bind.default.bind(_styles);

const Digit = (0, _mobxReact.observer)(({
  dataTestId,
  character,
  height,
  size,
  color,
  fontVariant,
  ...props
}) => {
  const [offset, setOffset] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    if (height > 0) {
      setOffset((parseInt(character.character, 10) + (character.unused ? 0 : 10)) * height);
    }
  }, [character, height]);
  return _react.default.createElement("div", {
    "data-testid": dataTestId,
    "data-digit": character.character,
    "data-offset": offset,
    className: styles('digit'),
    ...props
  }, _react.default.createElement(_.Text, {
    className: styles('sizing-text'),
    size: size,
    color: color,
    variant: fontVariant,
    text: '9'
  }), _react.default.createElement("div", {
    className: styles('digit-slider'),
    style: {
      transform: `translateY(-${offset}px)`
    }
  }, _react.default.createElement(_.Text, {
    size: size,
    color: color,
    variant: fontVariant,
    text: '0'
  }), _react.default.createElement(_.Text, {
    size: size,
    color: color,
    variant: fontVariant,
    text: '1'
  }), _react.default.createElement(_.Text, {
    size: size,
    color: color,
    variant: fontVariant,
    text: '2'
  }), _react.default.createElement(_.Text, {
    size: size,
    color: color,
    variant: fontVariant,
    text: '3'
  }), _react.default.createElement(_.Text, {
    size: size,
    color: color,
    variant: fontVariant,
    text: '4'
  }), _react.default.createElement(_.Text, {
    size: size,
    color: color,
    variant: fontVariant,
    text: '5'
  }), _react.default.createElement(_.Text, {
    size: size,
    color: color,
    variant: fontVariant,
    text: '6'
  }), _react.default.createElement(_.Text, {
    size: size,
    color: color,
    variant: fontVariant,
    text: '7'
  }), _react.default.createElement(_.Text, {
    size: size,
    color: color,
    variant: fontVariant,
    text: '8'
  }), _react.default.createElement(_.Text, {
    size: size,
    color: color,
    variant: fontVariant,
    text: '9'
  }), _react.default.createElement(_.Text, {
    size: size,
    color: color,
    variant: fontVariant,
    text: '0'
  }), _react.default.createElement(_.Text, {
    size: size,
    color: color,
    variant: fontVariant,
    text: '1'
  }), _react.default.createElement(_.Text, {
    size: size,
    color: color,
    variant: fontVariant,
    text: '2'
  }), _react.default.createElement(_.Text, {
    size: size,
    color: color,
    variant: fontVariant,
    text: '3'
  }), _react.default.createElement(_.Text, {
    size: size,
    color: color,
    variant: fontVariant,
    text: '4'
  }), _react.default.createElement(_.Text, {
    size: size,
    color: color,
    variant: fontVariant,
    text: '5'
  }), _react.default.createElement(_.Text, {
    size: size,
    color: color,
    variant: fontVariant,
    text: '6'
  }), _react.default.createElement(_.Text, {
    size: size,
    color: color,
    variant: fontVariant,
    text: '7'
  }), _react.default.createElement(_.Text, {
    size: size,
    color: color,
    variant: fontVariant,
    text: '8'
  }), _react.default.createElement(_.Text, {
    size: size,
    color: color,
    variant: fontVariant,
    text: '9'
  })));
});
const NumberTicker = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  variant,
  showDecimals,
  value,
  size,
  color,
  fontVariant,
  prefixClassName,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('number-ticker'), className);
  const [prefix, setPrefix] = (0, _react.useState)('');
  const [displayValue, setDisplayValue] = (0, _react.useState)('');
  const [displayCharacters, setDisplayCharacters] = (0, _react.useState)([]);
  const [activeCharacters, setActiveCharacters] = (0, _react.useState)([]);
  const [sizingRef, {
    width: measuredWidth,
    height: measuredHeight
  }] = (0, _reactUseMeasure.default)({
    polyfill: _resizeObserver.ResizeObserver
  });
  const [prefixRef, {
    width: measuredPrefixWidth,
    height: measuredPrefixHeight
  }] = (0, _reactUseMeasure.default)({
    polyfill: _resizeObserver.ResizeObserver
  });
  const [dimensions, setDimensions] = (0, _react.useState)({
    width: measuredWidth,
    height: measuredHeight,
    prefixWidth: measuredPrefixWidth,
    prefixHeight: measuredPrefixHeight
  });
  (0, _react.useEffect)(() => {
    setDimensions({
      width: measuredWidth > 0 ? measuredWidth : dimensions.width,
      height: measuredHeight > 0 ? measuredHeight : dimensions.height,
      prefixWidth: measuredPrefixWidth > 0 ? measuredPrefixWidth : dimensions.prefixWidth,
      prefixHeight: measuredPrefixHeight > 0 ? measuredPrefixHeight : dimensions.prefixHeight
    });
  }, [measuredWidth, measuredHeight, measuredPrefixWidth, measuredPrefixHeight]);
  (0, _react.useEffect)(() => {
    let stringValue = `${Math.abs(variant === 'percentage' ? value * 100 : value)}`;
    const characters = [];

    if (showDecimals !== false && (stringValue.indexOf('.') > -1 || showDecimals === true)) {
      const parts = stringValue.split(/\./);
      stringValue = parts.shift() || '';
      const decimal = parts[0];
      characters.unshift({
        key: 'decimal-2',
        character: (decimal === null || decimal === void 0 ? void 0 : decimal[1]) || '0',
        useDigit: true
      });
      characters.unshift({
        key: 'decimal-1',
        character: (decimal === null || decimal === void 0 ? void 0 : decimal[0]) || '0',
        useDigit: true
      });
      characters.unshift({
        key: 'decimal',
        character: '.',
        useDigit: false
      });
    }

    let commaIndex = 0;

    for (let i = stringValue.length - 1; i >= 0; i--) {
      if (commaIndex > 2) {
        commaIndex = 0;
        characters.unshift({
          key: `comma-${stringValue.length - i}`,
          character: ',',
          useDigit: false
        });
      }

      characters.unshift({
        key: `number-${stringValue.length - i}`,
        character: stringValue[i],
        useDigit: true
      });
      commaIndex++;
    }

    let nextPrefix = value < 0 ? '-' : '';

    if (variant === 'currency') {
      nextPrefix += '$';
    } else if (variant === 'percentage') {
      nextPrefix += '%';
    }

    if (value === 0) {
      characters.forEach(character => character.unused = true);
    }

    if (characters.length >= activeCharacters.length) {
      setActiveCharacters(characters.slice(0));
    } else {
      const active = [];

      for (let i = 0; i < activeCharacters.length - characters.length; i++) {
        const character = activeCharacters[i];

        if (character.useDigit) {
          character.character = '0';
          character.unused = true;
        }

        active.push({ ...character
        });
      }

      active.push(...characters.slice(0));
      setActiveCharacters(active);
    }

    setDisplayCharacters(characters);
    setDisplayValue(nextPrefix + characters.map(c => c.character).join(''));
    setPrefix(nextPrefix);
  }, [value, variant, showDecimals]);
  return _react.default.createElement("div", {
    "data-testid": dataTestId,
    "data-display-value": displayValue,
    className: composed_classname,
    style: {
      width: `${dimensions.width}px`
    },
    ...props
  }, _react.default.createElement(_.Text, {
    className: styles('sizing-text'),
    size: size,
    color: color,
    variant: fontVariant,
    text: displayValue
  }), prefix.length > 0 && _react.default.createElement("div", {
    className: styles('prefix'),
    style: {
      width: dimensions.prefixWidth,
      height: dimensions.prefixHeight
    }
  }, _react.default.createElement(_.Text, {
    className: (0, _bind.default)(styles('prefix-text'), prefixClassName),
    dataTestId: dataTestId && `${dataTestId}-prefix`,
    text: prefix,
    size: size,
    color: color,
    variant: fontVariant
  })), _react.default.createElement("div", {
    className: styles('sizing-ref'),
    ref: sizingRef
  }, prefix.length > 0 && _react.default.createElement(_.Text, {
    className: prefixClassName,
    text: prefix,
    size: size,
    color: color,
    variant: fontVariant,
    ref: prefixRef
  }), displayCharacters.map(character => _react.default.createElement(_.Text, {
    key: character.key,
    text: character.useDigit ? '9' : character.character,
    size: size,
    color: color,
    variant: fontVariant
  }))), _react.default.createElement("div", {
    className: styles('digit-bar'),
    style: {
      width: `${dimensions.width - dimensions.prefixWidth}px`,
      height: `${dimensions.height}px`
    }
  }, _react.default.createElement("div", {
    className: styles('digit-bar-content')
  }, activeCharacters.map((character, index) => {
    if (character.useDigit) {
      return _react.default.createElement(Digit, {
        key: character.key,
        dataTestId: dataTestId && `${dataTestId}-index-${index}`,
        character: character,
        height: dimensions.height,
        size: size,
        color: color,
        fontVariant: fontVariant
      });
    } else {
      return _react.default.createElement(_.Text, {
        key: character.key,
        dataTestId: dataTestId && `${dataTestId}-index-${index}`,
        text: character.character,
        size: size,
        color: color,
        variant: fontVariant
      });
    }
  }))));
});
var _default = NumberTicker;
exports.default = _default;